import { observable, action, runInAction, toJS } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';

import Color from '@tool/color';
import { newRate, newValue } from '@tool/index';

const moTimeTrend = observable({
  type: 'chart', // chart, table
  xData: <any[]>[],
  yData: <any[]>[],
  overview: <any[]>[],
  labels: <any[]>[],
  tableLeft: <any[]>[],
  tableRight: <any[]>[],
});

const initTimeTrend = action((res: any) => {
  const { type } = moTimeTrend;

  const tempType = localStorage.getItem('indicatorType2') || '';
  if (tempType && (tempType !== type)) moTimeTrend.type = tempType;
  else localStorage.setItem('indicatorType2', type);

  if (isEmpty(res)) return;

  let xData: any[] = [];
  let yData: any[] = [];
  let overview: any[] = [];
  let tableLeft: any[] = [];
  let tableRight: any[] = [];

  res.data?.map((item: any) => {
    xData.push(item.date);
    if (item.tag === 'predict') {
      yData.push({
        value: item.change_rate,
        itemStyle: {
          color: Color.primaryColor(0.2),
          borderWidth: 1,
          borderType: 'dashed',
          border: `1px solid ${Color.primary}`,
          borderColor: Color.primaryColor(1),
        },
      });
    } else {
      yData.push(item.change_rate);
    }
    tableLeft.push(item.date);
  });
  tableLeft.unshift('年度');

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      if (child.mark === 'change_rate') {
        text += newRate(child.value);
      } else {
        text += child.value;
      }
    });
    overview.push(text);
  });

  tableRight.push(['涨薪率', '统计周期']);
  res.data?.map((item: any) => {
    tableRight.push([newRate(item.change_rate), item.date_period]);
  });

  moTimeTrend.xData = xData;
  moTimeTrend.yData = yData;
  moTimeTrend.tableLeft = tableLeft;
  moTimeTrend.tableRight = tableRight;
  moTimeTrend.overview = overview;
  moTimeTrend.labels = res.total_industry_data || [];
});

const changeType = action((type: string) => {
  moTimeTrend.type = type;
  localStorage.setItem('indicatorType2', type);
});

export default moTimeTrend;
export { initTimeTrend, changeType };
